<mat-divider class="grid-col-span-2"></mat-divider>
<p class="text light fx-flex-100 p-16 grid-col-span-2 space-nowrap" style="margin-block-end: 0">
  {{ 'DOCUMENT.CRAWLER_SSL_CERTIFICATE' | translate }}
</p>
<div class="grid-col-span-2 grid-2-columns align-items-start justify-content-start">
  <!-- Issuer -->
  <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-50 border-box p-16">
    <p class="text light fx-flex-100 mb-4 space-nowrap">
      {{ 'DOCUMENT.SSL_ISSUER' | translate }}
    </p>
    <span style="overflow-wrap: break-word;">{{ cert().issuer }}</span>
  </div>
  <!-- Validity dates -->
  <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-50 border-box p-16"
       style="gap: 6px;">
    <p class="text light fx-flex-100 mb-4 space-nowrap">
      {{ 'DOCUMENT.SSL_VALID_FROM' | translate }}
    </p>
    <time [dateTime]="cert().validity.from" class="space-nowrap"
          [matTooltipClass]="{ 'uzai-tooltip': true }"
          [matTooltip]="isoFromDate()">
      {{ readableFromDate() }}
    </time>
    <span class="text light">{{ 'DOCUMENT.SSL_VALID_TO' | translate }}</span>
    <time [dateTime]="cert().validity.to" class="space-nowrap"
          [matTooltipClass]="{ 'uzai-tooltip': true }"
          [matTooltip]="isoToDate()">
      {{ readableToDate() }}
    </time>
  </div>
  <!-- Validity badge -->
  <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-50 border-box p-16">
    <p class="text light fx-flex-100 mb-4">{{ 'DOCUMENT.SSL_VALIDITY' | translate }}</p>
    @if (isValid()) {
      <p class="chip green">{{ 'DOCUMENT.SSL_VALID' | translate }}</p>
    } @else {
      <p class="chip red">{{ 'DOCUMENT.SSL_EXPIRED' | translate }}</p>
    }
  </div>
  <!-- Serial number -->
  <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-50 border-box p-16">
    <p class="text light fx-flex-100 mb-4">{{ 'DOCUMENT.SSL_SERIAL' | translate }}</p>
    <code class="break-word small">{{ cert().serialNumber }}</code>
  </div>
  <!-- Fingerprint -->
  <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-50 border-box p-16">
    <p class="text light fx-flex-100 mb-4">{{ 'DOCUMENT.SSL_FINGERPRINT' | translate }}</p>
    <code class="break-word small">{{ cert().fingerprint }}</code>
  </div>
  <!-- Subject SANs -->
  @if (parsedSans().length > 0) {
    <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex-50 border-box p-16">
      <p class="text light fx-flex-100 mb-4">
        {{ 'DOCUMENT.SSL_DOMAINS' | translate }} ({{ parsedSans().length }})
      </p>
      <ul class="fx-row fx-wrap domains-list">
        @for (domain of parsedSans(); track domain) {
          <li class="chip light monospace small">{{ domain }}</li>
        }
      </ul>
    </div>
  }
</div>
<mat-divider class="grid-col-span-2"></mat-divider>
